import React from 'react'
import Box from '@mui/material/Box';
import { Button, MenuItem, Typography } from '@mui/material';
import style from './Payment.module.css';


const PaymentDay = () => {
 
     const [form, setForm] = React.useState({
         paymentSlip: null,
     });
 
     const handleFileChange = (e) => {
         const { name,value, files } = e.target;
         if(name === 'paymentSlip') {
             const file = files[0];
             if(file) {
                 setForm({...form, paymentSlip: file[0]});
             } else {
                 setForm({...form, [name]: value})
             }
         }
     }
 
     const handleSubmit = () => {
         if (!form.paymentSlip || !form.customerName || !form.email) {
       alert('Please complete all payment fields and upload a payment slip.');
       return;

     }
     }
   return (
     <Box className={style.formContainer}>
       <h1>Payment</h1>
       <input
       type="text"
       name="fullName"
       placeholder="Enter your full name"
       value={form.fullName}
       />
      <input
       type="email"
       name="email"
       placeholder="Enter your email"
       value={form.email}
       />
       <input
       type="text"
       name="customerName"
       placeholder="Enter your purpose"
       value={form.customerName}
       />
        <input   
        type="file"
        accept="image/*,application/pdf"
        onChange={handleFileChange}
        style={{ marginTop: '16px'}}
       />
       <Button variant="contained" onClick={handleSubmit} sx={{ mt: 3}}>
         Upload Payment Slip
       </Button>
     </Box>
   )
 }

export default PaymentDay